var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9808 3.01986C20.1108 2.14986 18.8808 1.80986 17.6908 2.10986L7.89084 4.55986C6.24084 4.96986 4.97084 6.24986 4.56084 7.88986L2.11084 17.6999C1.81084 18.8899 2.15084 20.1199 3.02084 20.9899C3.68084 21.6399 4.55084 21.9999 5.45084 21.9999C5.73084 21.9999 6.02084 21.9699 6.30084 21.8899L16.1108 19.4399C17.7508 19.0299 19.0308 17.7599 19.4408 16.1099L21.8908 6.29986C22.1908 5.10986 21.8508 3.87986 20.9808 3.01986ZM12.0008 15.8799C9.86084 15.8799 8.12084 14.1399 8.12084 11.9999C8.12084 9.85986 9.86084 8.11986 12.0008 8.11986C14.1408 8.11986 15.8808 9.85986 15.8808 11.9999C15.8808 14.1399 14.1408 15.8799 12.0008 15.8799Z",
    fill: "#000014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartups);
export default __webpack_public_path__ + "static/media/startups.e99bf4fd07eee21aced8e16cf449fe6a.svg";
export { ForwardRef as ReactComponent };